import { createFileRoute } from '@tanstack/react-router';

import { ProjectEditInternalPartNumberOfferPage } from '@/areas/offers/StandardPartOfferForm/pages/ProjectEditInternalPartNumberOfferPage';
import { sourcingEditModulePermissions } from '@/shared/permissions/pagePermissions';
import type { PageStaticData } from '@/shared/routing';

export const Route = createFileRoute(
    '/_authenticated/next/projects/$projectId/sourcing/offers/internal-part-number/$offerId/edit',
)({
    staticData: {
        access: { permissions: ['view:sourcing'], modulePermissions: sourcingEditModulePermissions },
        chrome: 'none',
    } satisfies PageStaticData,
    component: RouteComponent,
});

function RouteComponent(): JSX.Element {
    const pathParams = Route.useParams();
    return <ProjectEditInternalPartNumberOfferPage projectId={pathParams.projectId} offerId={pathParams.offerId} />;
}
